import React, { useMemo } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Link,
  Typography,
} from '@mui/material';

const PickupDetailDialog = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen((prev) => !prev);
  };

  const pickupSections = useMemo(() => {
    return [
      {
        id: 'intro',
        type: 'intro',
        text: (
          <>
            <Typography variant='body1' component='p' gutterBottom>
              Please pick up your Angels wishes at the location you selected in
              your application. You will need to present your QR code or
              confirmation number at the time of pick-up. You can find your QR
              code or confirmation number in the confirmation email that you
              should have received after submitting your application.
            </Typography>

            <Typography variant='body1' component='p' gutterBottom>
              To make any changes to your pick-up location, don't hesitate to
              contact us directly at{' '}
              <Link color='primary' href='mailto:angeltree@ufvsus.ca'>
                angeltree@ufvsus.ca
              </Link>{' '}
              or call{' '}
              <Link color='primary' href='tel:6048644613'>
                604-864-4613
              </Link>
              .
            </Typography>
          </>
        ),
      },
      {
        id: 'abbotsford',
        title: 'Abbotsford Pick-up',
        location: {
          label: 'Student Union Society, Building S, Room S1109',
          href: 'https://www.ufv.ca/maps/abbotsford-campus/',
        },
        dates: 'Dec 9 & Dec 10',
        hours: '9:00 am to 8:30 pm',
      },
      {
        id: 'chilliwack',
        title: 'Chilliwack Pick-up',
        location: {
          label: 'CEP Campus, Building A, Room A1318',
          href: 'https://www.ufv.ca/maps/chilliwack-campus/',
        },
        dates: 'Dec 7 & Dec 8',
        hours: '9:00 am to 8:30 pm',
      },
    ];
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>Pick-up Details</DialogTitle>
      <DialogContent>
        <DialogContentText component='div'>
          {pickupSections.map((section) => {
            if (section.type === 'intro') {
              return (
                <Box key={section.id}>
                  {section.text}
                  <Divider sx={{ marginTop: 2 }} />
                </Box>
              );
            }

            return (
              <Box key={section.id} sx={{ marginTop: 2 }}>
                <Typography variant='subtitle1' component='p' fontWeight='bold'>
                  {section.title}
                </Typography>

                <Typography variant='body2' component='p'>
                  <span style={{ fontWeight: 'bold' }}>Location:</span>{' '}
                  <Link color='primary' href={section.location.href}>
                    {section.location.label}
                  </Link>
                </Typography>

                <Typography variant='body2' component='p'>
                  <span style={{ fontWeight: 'bold' }}>Dates:</span>{' '}
                  {section.dates}
                </Typography>

                <Typography variant='body2' component='p'>
                  <span style={{ fontWeight: 'bold' }}>Hours:</span>{' '}
                  {section.hours}
                </Typography>

                <Divider sx={{ marginTop: 2 }} />
              </Box>
            );
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleClose} autoFocus>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PickupDetailDialog;
